export interface blogPost {
  excerpt: string;
  coverImage: string;
  cardImageAlt: string;
  relatedDepartments: string[];
  linkCopy: string;
  linkType: string;
  linkHref: string;
  backgroundColor: string;
}

export const blogPosts: blogPost[] = [
  {excerpt:"Would you let Elon babysit your children?",coverImage:"./images/ADM_Blog_5.webp",cardImageAlt:"",relatedDepartments:["Technology"],linkCopy:"Read more",linkType:"external",linkHref:"https://www.addmustard.com/blog/let-elon-babysit-your-children/",backgroundColor:"#000"},
  {excerpt:'"Oi you". Yes you.',coverImage:"./images/ADM_Blog_4.webp",cardImageAlt:"",relatedDepartments:["Marketing"],linkCopy:"Read more",linkType:"external",linkHref:"https://www.addmustard.com/blog/oi-you-yes-you",backgroundColor:"#000"},
  {excerpt:"Does my brand look big in this?",coverImage:"./images/ADM_Blog_3.webp",cardImageAlt:"",relatedDepartments:["Marketing"],linkCopy:"Read more",linkType:"external",linkHref:"https://www.addmustard.com/blog/does-my-brand-look-big-in-this/",backgroundColor:"#000"},
];
